var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('div',{staticClass:"d-flex justify-end align-end mx-6"},[(_vm.canCreateGroupHead)?_c('CreateGroupHeadDialog'):_vm._e()],1),_c('GroupHeadDetail')],1)}
var staticRenderFns = []

export { render, staticRenderFns }